import { useCallback } from 'react';

import type { ChipGroupProps } from '@components/tenantStatus/onboardingWizard/types';

export type UseManageChipGroupParams = Pick<ChipGroupProps, 'selected' | 'multiSelect' | 'onChange'>;

export const useManageChipGroup = ({ selected, multiSelect, onChange }: UseManageChipGroupParams) => {
  const handlePress = useCallback(
    (value: string) => {
      if (!multiSelect) {
        onChange(selected.includes(value) ? [] : [value]);
        return;
      }
      const isSelected = selected.includes(value);
      onChange(isSelected ? selected.filter((v) => v !== value) : [...selected, value]);
    },
    [multiSelect, onChange, selected]
  );

  return { handlePress };
};
